import {Vue, Component, Prop} from 'vue-property-decorator';
import * as tsx from 'vue-tsx-support';
import {ModalStateName} from '@/store/HomeStore';

import timestampToDate from '@/utils/timestampToDate';
import getSystemInfo from '@/utils/getSystemInfo';
import DeviceMask from '@/components/Device/Mask';
import {justifyContent} from '@/components/Device';

import Log from '@/components/Log';

import './style.less';
import Bad from '@/components/Device/Bad';

interface IPhone {
  events?: any;
  data?: object;
  activeType?: any
  justifyContent?: justifyContent
}

@Component

export default class Phone extends tsx.Component<IPhone> {
  
  @Prop() public events?: any
  @Prop() public data?: object
  @Prop() public activeType?: any
  @Prop() public justifyContent?: justifyContent
  
  state = {
    setup: false,
    time: 0,
    type: 0 // 0 不展示 1 小于一天 2 小于半小时
  }
  
  setTime () {
    this.state.time = this.$props.data.remainTime
    if (this.state.time <= 86400) {
      this.state.type =  1
    }
    const setIntervalTime =  setInterval(() => {
      if (this.state.time <= 86400) {
        this.state.type =  1
      }
      if (this.state.time <= 0) {
        clearInterval(setIntervalTime)
        return false
      }
      this.state.time = this.state.time - 60 // 1分钟定时执行
    }, 1000 * 60)
  }
  
  mounted () {
    this.setTime()
    let img: any = this.$refs.img
    img.onerror = () => {
      img.src = require('@/assets/img/phone-bg.jpg')
    }
  }
  
  getClassName (type:justifyContent) {
    if (type === justifyContent.left) {
      return 'phone-container-left'
    }
    if (type === justifyContent.right) {
      return 'phone-container-right'
    }
    return 'phone-container-center'
  
  }
  
  render() {
    const {data, events, activeType} = this.$props;
    const narrow = activeType ? 1 : 0.8
    let {height , width} = getSystemInfo().deviceSize
    height = height * narrow;
    width = width * narrow;
    return (
      <div class={`phone-container ${this.getClassName(this.$props.justifyContent)}`} style={`height:${height + 60}px; width:${width}px;`}>
        <div class='screen' style={`height:${height}px; width:${width}px`}>
          
          {data.refreshStatus === true ?
            <div class='loading'>
              <img class='loading-img' src={require('@/assets/gif/LOADING.gif')} />
            </div> :
            <img style={`background: url(${data.screenImageUri || require('@/assets/img/phone-bg.jpg')});background-size: 100% 100%;`} onClick={() => events.cloudDevicePlay(data.id)} class='img' ref='img' />
          }
          
          {/*<div onClick={() => events.cloudDeviceRefresh()} class='refresh'>*/}
            {/*刷新*/}
          {/*</div>*/}
          {data.screenImageUri ? null :
            <div class="text">
              <span class="top">恭喜购买成功</span>
              <span class="bottom">点击屏幕任意位置，进入云手机</span>
            </div>
            
          }
          <DeviceMask type={this.$props.justifyContent} events={events} data={data} time={data.remainTime} />
        </div>
        
        <div class='bottom'>
          <div class='setup' onClick={() => this.state.setup = !this.state.setup}>
            {
              this.state.setup ? <img src={require('@/assets/svg/back.svg')} alt=""/> : <Log number='H002'>设置</Log>
            }
          </div>
          <img class='arc' src={require('@/assets/img/arc.png')} alt=""/>
          {this.state.setup ?
            <div class='setup-button'>
              <div onClick={() => {this.$props.events.modalVisible(ModalStateName.renameModalState)}} class='item'>
                <div class='icon'>
                  <img  src={require('@/assets/svg/rename.svg')}  />
                </div>
                <div class='text'>重命名</div>
              </div>
              <div onClick={() => {this.$props.events.modalVisible(ModalStateName.restartModalState)}} class='item'>
                <div class='icon' >
                  <img src={require('@/assets/svg/重启.svg')} />
                </div>
                <div class='text'>重启</div>
              </div>
              <div onClick={() => {this.$props.events.modalVisible(ModalStateName.restoreModalState)}} class='item'>
                <div class='icon' >
                  <img src={require('@/assets/svg/恢复设置.svg')}/>
                </div>
                <div class='text'>恢复设置</div>
              </div>
              <div onClick={() => {this.$props.events.modalVisible(ModalStateName.deviceNumberModalState)}} class='item'>
                <div class='icon' >
                  <img src={require('@/assets/svg/设备号.svg')}/>
                </div>
                <div class='text'>设备号</div>
              </div>
            </div> : null
          }
          {this.state.setup ? null :
            <div class='text' >
              <div class='name'>{data.title}</div>
              <div class='time'>{timestampToDate(data.remainTime)}</div>
            </div>
          }
          {this.state.setup ? null :
            <Log number='H003'>
              <div onClick={() => events.routerPushPackage(data)} class='button'>
                续费
              </div>
            </Log>
          }
        </div>
      </div>
    )
  }
  
}